import type MastPartsDto from "../../../../dto/construction/parts/MastPartsDto";
import type BeamPartsDto from "../../../../dto/construction/parts/BeamPartsDto";
import type CatenaryPartsDto from "../../../../dto/construction/parts/CatenaryPartsDto";
import type SupportArmPartsDto from "../../../../dto/construction/parts/SupportArmPartsDto";
import type HingedCantileverPartsDto from "../../../../dto/construction/parts/HingedCantileverPartsDto";
import type DevicePartsDto from "../../../../dto/construction/parts/DevicePartsDto";
import type WirePartsDto from "../../../../dto/construction/parts/WirePartsDto";
import type HiddenConstructionElementPartsDto from "../../../../dto/construction/parts/HiddenConstructionElementPartsDto";
import type ConstructionAllDetailsGuiDto from "../../../../dto/construction/ConstructionAllDetailsGuiDto";
import type CrossSpanWirePartsDto from "../../../../dto/construction/parts/CrossSpanWirePartsDto";

interface ConstructionBodyProps {
  construction: ConstructionAllDetailsGuiDto;
}

type ConstructionPartType =
  | MastPartsDto
  | BeamPartsDto
  | CrossSpanWirePartsDto
  | CatenaryPartsDto
  | SupportArmPartsDto
  | HiddenConstructionElementPartsDto
  | HingedCantileverPartsDto
  | DevicePartsDto
  | WirePartsDto;

interface ConstructionBodyBlockProps {
  constructionId: string;
  constructionPart: ConstructionPartType;
  name: string;
  isAccepted: boolean;
}

const exceptionParts: string[] = ["hiddenConstructionElementParts"];

export {type ConstructionBodyProps, type ConstructionBodyBlockProps, exceptionParts};
